// 예약 달력 공휴일 Redux slice

import { createSlice } from "@reduxjs/toolkit"
import { fetchReservationHolidayMonth } from "@core/api/reservationHolidayApi"
import type { ReservationHolidayMonthResponse } from "@core/api/reservationHolidayApi"

export interface HolidayCalendarState {
  months: Record<string, ReservationHolidayMonthResponse>
  loadingByMonth: Record<string, boolean>
  errorByMonth: Record<string, string | null>
}

const initialState: HolidayCalendarState = {
  months: {},
  loadingByMonth: {},
  errorByMonth: {},
}

const holidayCalendarSlice = createSlice({
  name: "holidayCalendar",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchReservationHolidayMonth.pending, (state, action) => {
        const { year, month } = action.meta.arg
        const ym = `${year}-${String(month).padStart(2, "0")}`
        state.loadingByMonth[ym] = true
        state.errorByMonth[ym] = null
      })
      .addCase(fetchReservationHolidayMonth.fulfilled, (state, action) => {
        const data = action.payload
        state.months[data.yearMonth] = data
        state.loadingByMonth[data.yearMonth] = false
      })
      .addCase(fetchReservationHolidayMonth.rejected, (state, action) => {
        const { year, month } = action.meta.arg
        const ym = `${year}-${String(month).padStart(2, "0")}`
        state.loadingByMonth[ym] = false
        state.errorByMonth[ym] = (action.payload as string) || "공휴일 조회 실패"
      })
  },
})

export default holidayCalendarSlice.reducer
